<template>
  <section id="info">
    <h2> </h2>
    <h3> </h3>
    <h2> </h2>
    <h3> </h3>
    <h2>STUDIO PAUL</h2>
    <h3>email: paulstudio.paul@gmail.com</h3>
  </section>
</template>

<script>
export default {
  name: 'InfoSection'
};
</script>

<style scoped>
#info {
  display: flex;
  flex-direction: column;
  padding-top: 2vw;
  background-color: transparent;
  color: #0026ff;
  text-align: center;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
}

h2 {
  /* margin-bottom: 3vh; */
  margin-bottom: -0.5vh;
  font-size: 3vh;
  position: sticky;
}

h3 {
  margin-bottom: 2vh;
  font-size: 2vh;
  color: #f4f4f4;
  max-width: 80vw;
}
</style>